import React, { useState, useCallback } from "react";
import { Box, ThemeProvider, CssBaseline } from "@mui/material";
import { Outlet } from "react-router-dom";
import InvestorSidebar from "./InvestorSidebar";
import InvestorHeader from "./InvestorHeader";

import {
  DRAWER_WIDTH,
  DRAWER_WIDTH_COLLAPSED,
  SIDEBAR_TRANSITION_MS,
  createDashboardTheme,
} from "../../theme/dashboardShell";

const theme = createDashboardTheme();

const STORAGE_KEY = "investorSidebarCollapsed";

export default function InvestorMainpage() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "1";
    } catch {
      return false;
    }
  });

  const toggleSidebar = useCallback(() => {
    setSidebarCollapsed((c) => {
      const next = !c;
      try {
        localStorage.setItem(STORAGE_KEY, next ? "1" : "0");
      } catch {
        /* ignore */
      }
      return next;
    });
  }, []);

  const drawerWidth = sidebarCollapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <InvestorSidebar
        open={mobileNavOpen}
        onClose={() => setMobileNavOpen(false)}
        collapsed={sidebarCollapsed}
        onToggleCollapse={toggleSidebar}
      />
      <Box
        sx={{
          ml: { xs: 0, md: `${drawerWidth}px` },
          width: { xs: "100%", md: `calc(100% - ${drawerWidth}px)` },
          minHeight: "100dvh",
          bgcolor: "background.default",
          display: "flex",
          flexDirection: "column",
          transition: (t) =>
            t.transitions.create(["margin", "width"], {
              easing: t.transitions.easing.sharp,
              duration: SIDEBAR_TRANSITION_MS,
            }),
        }}
      >
        <InvestorHeader onMenuClick={() => setMobileNavOpen(true)} />

        <Box sx={{ p: { xs: 2, sm: 3 }, flexGrow: 1 }}>
          <Outlet />
        </Box>
      </Box>
    </ThemeProvider>
  );
}
